<!-- Trigger button -->
<button
  #trigger
  type="button"
  (click)="toggle()"
  [disabled]="isDisabled()"
  [attr.aria-expanded]="isOpen()"
  aria-haspopup="dialog"
  class="border-weak focus:border-accent-focus focus:ring-accent-focus flex h-9 w-full items-center gap-2.5 rounded-md border px-3 py-1.5 text-left text-sm focus:ring-1 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60">
  @if (showsNoColor()) {
    <span class="border-default size-4 shrink-0 rounded-full border border-dashed"></span>
    <span class="text-text-tertiary flex-1 text-sm">{{
      'form.default_color' | translate
    }}</span>
  } @else {
    <span
      class="size-4 shrink-0 rounded-full border border-zinc-300 dark:border-zinc-600"
      [style.background-color]="currentValue()">
    </span>
    <span class="flex-1 font-mono text-sm">{{ currentValue() }}</span>
  }
  <svg
    aria-hidden="true"
    class="text-text-tertiary duration-base h-4 w-4 shrink-0 transition-transform"
    [class.rotate-180]="isOpen()"
    fill="currentColor"
    viewBox="0 0 20 20">
    <path
      clip-rule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
      fill-rule="evenodd" />
  </svg>
</button>

<!-- Floating panel -->
<app-dropdown
  [target]="trigger"
  [template]="colorPanel"
  [isOpen]="isOpen()"
  [onClose]="close"
  [closeOnClickOutside]="true"
  [closeOnEscape]="true"
  [minWidth]="248" />

<ng-template #colorPanel>
  <div class="p-3" style="width: 248px">
    <!-- Preset swatches -->
    <div class="flex flex-wrap gap-2">
      @if (clearable()) {
        <button
          type="button"
          (click)="clear()"
          [attr.title]="'form.default_color' | translate"
          [attr.aria-label]="'form.default_color' | translate"
          [attr.aria-pressed]="isUnset()"
          class="border-default duration-fast size-7 cursor-pointer rounded-full border border-dashed transition-all focus:outline-none"
          [class]="swatchStateClass(isUnset())"></button>
      }
      @for (color of colors(); track color) {
        @let selected = isPresetSelected(color);
        <button
          type="button"
          (click)="selectPreset(color)"
          [style.background-color]="color"
          [attr.title]="color"
          [attr.aria-label]="color"
          [attr.aria-pressed]="selected"
          class="duration-fast size-7 cursor-pointer rounded-full transition-all focus:outline-none"
          [class]="swatchStateClass(selected)"
          [class.ring-1]="!selected"
          [class.ring-zinc-300]="!selected"></button>
      }
    </div>

    <!-- Divider -->
    <div class="border-weak my-3 border-t"></div>

    <!-- Custom color row: native picker + hex text input -->
    <div class="flex items-center gap-2">
      <div class="relative shrink-0">
        <span
          class="pointer-events-none absolute inset-0.5 rounded"
          [style.background-color]="currentValue()">
        </span>
        <input
          type="color"
          [value]="nativeColor()"
          (input)="onColorPickerInput($event)"
          class="h-8 w-10 cursor-pointer rounded border border-zinc-300 bg-transparent opacity-0 dark:border-zinc-600" />
      </div>
      <input
        type="text"
        [value]="showsNoColor() ? '' : hexInputValue()"
        (input)="onHexInput($event)"
        maxlength="7"
        placeholder="#000000"
        class="form-input min-w-0 flex-1 font-mono" />
    </div>
  </div>
</ng-template>
